import create from 'zustand';

import { getSingleSubmission } from '../../api/submission';
import { ISubmission } from '../../interfaces/submission';
import { processErrorMessage } from '../../utils/processErrorMessage';

interface SingleSubmissionState {
  submission: ISubmission | null;
  loading: boolean;
  error?: any;

  getSingleSubmission: (payload: { accessToken: string | null | undefined; id: string }) => Promise<void>;
  clearSingleSubmission: () => void;
}

export const useSingleSubmissionStore = create<SingleSubmissionState>((set) => ({
  submission: null,
  loading: false,
  error: null,

  getSingleSubmission: async (payload) => {
    set({ loading: true });

    try {
      const { accessToken, id } = payload;
      const submission = await getSingleSubmission(accessToken, id);
      set({ submission });
    } catch (err) {
      set({ error: processErrorMessage(err) });
    }

    set({ loading: false });
  },

  clearSingleSubmission: () => {
    set({ submission: null });
  },
}));
